import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetWellnessProgramByClientName = async (clientId) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_WELLNESS_PROGRAM_BY_CLIENT_NAME + clientId,
    token
  );
  return res;
};

export const GetBenchmark = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_BENCHMARK, token);
  return res;
};

export const UpdateData = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(
    Url.UPDATE_CLIENT_WELLNESS_PROGRAM,
    payload,
    token
  );
  return res;
};
